import { gql } from '@apollo/client';

export const USER_DOCUMENTS_QUERY = gql`
  query {
    userDocuments {
      dateCreated
      documentUri
      documentLabel
      groupName
    }
    userTaxesDocuments {
      dateCreated
      documentUri
      documentLabel
      groupName
    }
  }
`;
